import { Component, Watch, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { CreateElement, VNode } from 'vue';
import type { ElForm } from 'element-ui/types/form';
import NewSelectSite from '../newSelectSIte';
import { IPSService } from '@/services/ipsServices';
import { noop, numberToArray } from '@/util';

const tencentVideo = 'https://v.qq.com/open/home.html';
const normalVideo = 'https://developers.weixin.qq.com/miniprogram/product/material';

@Component({})
export default class AddVideo extends Vue {
  @Prop()
    value: boolean;

  @Prop({ default: 0 })
    videoId: number;

  @Prop({ default: 0 })
    sgId: number;

  @Prop({ default: 0 })
    sgwpId: number;

  @Prop({ default: false })
    readOnly: boolean;

  @Prop({ default: '' })
    sgName: string;

  $refs: {
    videoForm: ElForm;
  };

  isShow = false;

  videoInfo: VideoInfo = {
    videoName: '',
    siteCodes: [],
    beginTime: 0,
    endTime: 0,
    videoSource: 1,
    videoUrl: '',
    isAutoPlay: 0,
    date: [],
  };

  isLong = false;

  rules = {
    videoName: [{ required: true, message: '请输入视频标题', trigger: 'blur' }],
    date: [{ required: true, validator: this.v_date, trigger: 'change' }],
    siteCodes: [{ required: true, message: '请选择适用网点', trigger: ['change', 'blur'] }],
    videoUrl: [{ required: true, message: '请输入视频地址', trigger: 'blur' }],
  };

  v_date(rule, value, callback) {
    if (this.isLong) {
      callback();
    }
    if (!value || !value[0] || !value[1]) {
      callback(new Error('请选择视频有效期'));
    } else {
      callback();
    }
  }

  @Watch('value')
  watch(n) {
    this.isShow = n;
    this.clearData();
    if (n && this.videoId) {
      this.getVideoInfo();
    }
  }

  @Watch('isShow')
  watchIsShow(n) {
    if (!n) {
      this.$emit('input', false);
    }
  }

  clearData() {
    this.videoInfo = {
      videoName: '',
      siteCodes: [],
      beginTime: 0,
      endTime: 0,
      videoSource: 1,
      videoUrl: '',
      isAutoPlay: 0,
      date: [],
    };
  }

  changeIsLong(val) {
    if (val) {
      this.videoInfo.date = [];
    }
  }

  openSelectSiteDialog() {
    new NewSelectSite().open({ sgId: this.sgId, selectCodes: this.videoInfo.siteCodes, readonly: this.readOnly }).then((response) => {
      this.videoInfo.siteCodes = response;
    }, noop);
  }

  getVideoInfo() {
    IPSService.gsVideoInfo({
      postParams: {
        videoId: this.videoId,
      },
    }).then((response: VideoInfo) => {
      this.videoInfo = Object.assign({}, response, { date: [] });
      if (response.beginTime && response.endTime) {
        this.videoInfo.date[0] = (response.beginTime as number) * 1000;
        this.videoInfo.date[1] = (response.endTime as number) * 1000;
      }
      this.isLong = response.beginTime === 0 && response.endTime === 0;
    });
  }

  // 点此了解详情
  openNewWindow() {
    window.open(this.videoInfo.videoSource == 1 ? tencentVideo : normalVideo);
  }

  onSave() {
    if (!this.videoInfo.date) {
      this.videoInfo.date = [];
    }
    this.videoInfo.beginTime = moment(this.videoInfo.date[0]).unix();
    this.videoInfo.endTime = moment(this.videoInfo.date[1]).unix();
    this.$refs.videoForm.validate((result) => {
      if (result) {
        IPSService.gsVideoEdit({
          postParams: {
            sgId: this.sgId,
            sgwpId: this.sgwpId,
            videoId: this.videoId,
            videoName: this.videoInfo.videoName,
            siteCodes: this.videoInfo.siteCodes,
            beginTime: this.isLong ? 0 : this.videoInfo.beginTime,
            endTime: this.isLong ? 0 : this.videoInfo.endTime,
            videoSource: this.videoInfo.videoSource,
            videoUrl: this.videoInfo.videoUrl,
            isAutoPlay: this.videoInfo.isAutoPlay,
          },
        }).then((response) => {
          this.$emit('save', false);
        });
      }
    });
  }

  onCancel() {
    this.isShow = false;
  }
}
